export function toAbsoluteExpiryMs(expiresIn: number | null | undefined): number {
  if (!expiresIn) return 0

  const expiryMs = expiresIn * 1000
  const now = Date.now()

  return expiryMs > now ? expiryMs : expiryMs + now
}
